/**
 * 与 Header 分类下拉（CategoriesMenuTwo）及 customPages / service 子目录分组约定一致：
 * groupLabelKey 对应 i18n `menuGroups.*`，目录名为键名最后一段（camelCase）。
 */

export interface CategoriesMenuItem {
	labelKey: string;
	slug: string;
}

export interface CategoriesMenuGroup {
	groupLabelKey: string;
	items: CategoriesMenuItem[];
}

/** 暂不展示的 Service 子菜单（恢复展示时从此 Set 中移除对应 slug） */
export const HIDDEN_SERVICE_SLUGS = new Set([
	// "aluminum-extrusion",
	// "spring-manufacturing",
	// "on-demand-manufacturing",
	// "assembly",
	// "industrial-automation",
]);

/** 所有子菜单均可点击；有独立页面的用 slug，无独立页面的可后续在 [slug] 中做兜底 */
export const MENU_GROUPS: CategoriesMenuGroup[] = [
	{
		groupLabelKey: "menuGroups.machiningServices",
		items: [
			{ labelKey: "menu.cnc-machining", slug: "cnc-machining" },
			{ labelKey: "menu.cnc-milling", slug: "cnc-milling" },
			{ labelKey: "menu.cnc-turning", slug: "cnc-turning" },
			{ labelKey: "menu.5-axis-cnc-machining", slug: "5-axis-cnc-machining" },
			{ labelKey: "menu.precisionMachining", slug: "precision-machining" },
		],
	},
	{
		groupLabelKey: "menuGroups.moldingServices",
		items: [
			{ labelKey: "menu.injection-molding", slug: "injection-molding" },
			{ labelKey: "menu.injection-mold-tooling", slug: "injection-mold-tooling" },
			{ labelKey: "menu.plastic-injection-molding", slug: "plastic-injection-molding" },
			{ labelKey: "menu.overmolding", slug: "overmolding" },
			{ labelKey: "menu.insert-molding", slug: "insert-molding" },
		],
	},
	{
		groupLabelKey: "menuGroups.castingServices",
		items: [
			{ labelKey: "menu.metal-casting", slug: "metal-casting" },
			{ labelKey: "menu.investment-casting", slug: "investment-casting" },
			// { labelKey: "menu.high-pressure-casting", slug: "high-pressure-casting" },
			// { labelKey: "menu.low-pressure-casting", slug: "low-pressure-casting" },
			{ labelKey: "menu.sand-casting", slug: "sand-casting" },
			{ labelKey: "menu.die-casting", slug: "die-casting" },
			{ labelKey: "menu.vacuum-casting", slug: "vacuum-casting" },
		],
	},
	{
		groupLabelKey: "menuGroups.fabricationServices",
		items: [
			{ labelKey: "menu.sheet-metal-fabrication", slug: "sheet-metal-fabrication" },
			{ labelKey: "menu.laser-cutting", slug: "laser-cutting" },
			{ labelKey: "menu.stamping", slug: "stamping" },
			{ labelKey: "menu.bending", slug: "bending" },
			{ labelKey: "menu.welding", slug: "welding" },
		],
	},
	{
		groupLabelKey: "menuGroups.more",
		items: [
			{ labelKey: "menu.3d-printing", slug: "3d-printing" },
			// { labelKey: "menu.sla-stereolithography", slug: "sla-stereolithography" },
			// { labelKey: "menu.mjf-multi-jet-fusion", slug: "mjf-multi-jet-fusion" },
			// { labelKey: "menu.fdm-fused-deposition-modeling", slug: "fdm-fused-deposition-modeling" },
			// { labelKey: "menu.sls-selective-laser-sintering", slug: "sls-selective-laser-sintering" },
			{ labelKey: "menu.gear-machining", slug: "gear-machining" },
			{ labelKey: "menu.aluminum-extrusion", slug: "aluminum-extrusion" },
			{ labelKey: "menu.spring-manufacturing", slug: "spring-manufacturing" },
			{ labelKey: "menu.rapid-prototyping", slug: "rapid-prototyping" },
		],
	},
	{
		groupLabelKey: "menuGroups.valueAddedSolutions",
		items: [
			{ labelKey: "menu.surface-finishing", slug: "surface-finishing" },
			{ labelKey: "menu.on-demand-manufacturing", slug: "on-demand-manufacturing" },
			{ labelKey: "menu.assembly", slug: "assembly" },
			{ labelKey: "menu.industrial-automation", slug: "industrial-automation" },
		],
	},
].map((group) => ({
	...group,
	items: group.items.filter((item) => !HIDDEN_SERVICE_SLUGS.has(item.slug)),
}));
